import PropTypes from "prop-types";
import React from "react";
import { popoverIconClassName, popoverTriggerClassName } from "./popoverIcon";

const Popover = ({
  content,
  icon = "info-circle",
  label = "More information",
  placement = "auto",
  width = "auto",
  trigger = "click",
}) => (
  <a
    href="# "
    className={popoverTriggerClassName(icon)}
    aria-label={label}
    data-app-popover="true"
    data-content={content}
    data-placement={placement}
    data-width={width}
    data-trigger={trigger}
  >
    <i className={popoverIconClassName(icon)} aria-hidden="true" />{" "}
  </a>
);

Popover.propTypes = {
  content: PropTypes.string.isRequired,
  icon: PropTypes.string,
  label: PropTypes.string,
  placement: PropTypes.string,
  width: PropTypes.string,
  trigger: PropTypes.string,
};

export default Popover;
